import { Sparkles } from "lucide-react";
import { EVENT_CONFIG } from "@/config/eventConfig";
import { SectionHeading, Reveal } from "./shared";

const Timeline = () => {
  const { galaProgram, images } = EVENT_CONFIG;

  return (
    <section id="gala" data-testid="gala-section" className="relative py-24 sm:py-32 bg-ink grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="06"
          eyebrow="The Gala Experience"
          title={
            <>
              A NIGHT OF ELEGANCE.
              <br />
              <span className="gold-shimmer">A MISSION WITH HEART.</span>
            </>
          }
          sub="Red carpet arrivals, dinner, impact stories and a dance floor that refuses to sit still."
        />

        <div className="mt-16 grid lg:grid-cols-2 gap-14 items-start">
          <div className="relative pl-8 sm:pl-10">
            <div className="absolute left-2 sm:left-3 top-1 bottom-1 w-px bg-gradient-to-b from-champagne/60 via-wine to-transparent" />
            {galaProgram.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.1} className="relative mb-10 last:mb-0">
                <span className="absolute -left-6 sm:-left-7 top-1.5 w-3.5 h-3.5 rounded-full bg-champagne shadow-[0_0_16px_rgba(230,199,134,0.7)]" />
                <div
                  data-testid={`gala-timeline-item-${i}`}
                  className={`rounded-2xl p-6 sm:p-7 gold-stroke ${item.vip ? "bg-wine/30" : "bg-coal/70"}`}
                >
                  <p className="text-gold text-xs uppercase tracking-[0.3em] flex items-center gap-2">
                    {item.time}
                    {item.vip && (
                      <span className="inline-flex items-center gap-1 text-champagne">
                        <Sparkles size={12} /> VIP
                      </span>
                    )}
                  </p>
                  <h3 className="font-serif text-xl sm:text-2xl text-ivory mt-2">{item.title}</h3>
                  <p className="text-cream/75 text-sm leading-relaxed mt-2">{item.detail}</p>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <p className="text-[11px] text-cream/40 uppercase tracking-[0.2em]">
                Program details are placeholders — official lineup announced by Styles 4 Kidz.
              </p>
            </Reveal>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {[images.ballroom, images.reception, images.toast, images.micMoment].map((src, i) => (
              <Reveal key={src} delay={i * 0.08} className={i % 2 === 1 ? "mt-8" : ""}>
                <div className="group overflow-hidden rounded-2xl gold-stroke">
                  <img
                    src={src}
                    alt="Styles 4 Kidz gala moment"
                    loading="lazy"
                    className="w-full h-56 sm:h-72 object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                  />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
